import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import * as ClaimTrackerModels from '@claim-tracker/common/models';
import isNil from 'lodash/isNil';

/**
 * Custom validator to validate login form control values.
 *
 * @param controlName the name of the form control to validate
 */
export function loginFormValidator(controlName: 'claimNumber' | 'name' | 'phoneNumber'): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		let error: ClaimTrackerModels.com.aoins.claims.login.LoginValidationError | null | undefined;

		switch (controlName) {
			case 'claimNumber':
				error = ClaimTrackerModels.com.aoins.claims.login.validateClaimNumber(control.value);
				break;
			case 'name':
				error = ClaimTrackerModels.com.aoins.claims.login.validateName(control.value);
				break;
			case 'phoneNumber':
				error = ClaimTrackerModels.com.aoins.claims.login.validatePhoneNumber(control.value);
				break;
		}

		return !isNil(error) ? { [`${error.type}`]: error.message } : null;
	};
}
